import { render, staticRenderFns } from "./BlocklyComponentParte.vue?vue&type=template&id=136b02b2&scoped=true&"
import script from "./BlocklyComponentParte.vue?vue&type=script&lang=js&"
export * from "./BlocklyComponentParte.vue?vue&type=script&lang=js&"
import style0 from "./BlocklyComponentParte.vue?vue&type=style&index=0&id=136b02b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b02b2",
  null
  
)

export default component.exports